import {
  apiDate,
  number,
  optional,
  optionalApiDate,
  optionalNumber,
  optionalString,
  optionalUuid,
  string,
  uuid,
  zodLess,
  ZodLessInfer,
} from '@kaiizen/zod-less';

export const ApiScanVideoSchema = zodLess({
  id: uuid,
  createdAt: apiDate,
  updatedAt: apiDate,
  scanId: uuid,
  mime: string,
  bytes: number, // ScanVideo.bytes is BigInt in the DB; converted at the model layer in Phase 2
  durationSeconds: optionalNumber,
  width: optionalNumber,
  height: optionalNumber,
  contentHash: optionalString,
  originalFileName: string,
  uploadedByUserId: uuid,
  videoRecordedAt: optionalApiDate,
  parentScanVideoId: optionalUuid,
});
export type ApiScanVideo = ZodLessInfer<typeof ApiScanVideoSchema>;

export const ApiScanVideoAudioSchema = zodLess({
  id: uuid,
  scanVideoId: uuid,
  startSeconds: number,
  endSeconds: number,
  text: optionalString,
  mime: optionalString,
  bytes: optional(number),
  createdAt: apiDate,
  updatedAt: apiDate,
});
export type ApiScanVideoAudio = ZodLessInfer<typeof ApiScanVideoAudioSchema>;

export const ApiGetScanVideosByIdsPayloadSchema = zodLess({
  scanVideoIds: [uuid],
});
export type ApiGetScanVideosByIdsPayload = ZodLessInfer<typeof ApiGetScanVideosByIdsPayloadSchema>;

export const ApiGetScanVideoAudiosByIdsPayloadSchema = zodLess({
  scanVideoAudioIds: [uuid],
});
export type ApiGetScanVideoAudiosByIdsPayload = ZodLessInfer<typeof ApiGetScanVideoAudiosByIdsPayloadSchema>;
